const styles = () => ({
  title: {
    textAlign: 'center',
  },
  buttonWrapper: {
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-around',
  },
  button: {
    marginTop: 20,
    marginBottom: 20,
    marginLeft: 10,
  },
  customPaper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 250,
  },
})

export default styles
